<template>
  <tr class="document financial-document">
    <td class="document-number">
      <span class="link" @click="handleloadFile" v-if="!document.file">
        Загрузить документ
      </span>
      <span v-else>
        <span class="link">{{document.file | path}}</span>
        <span class="delete-document" @click="deleteDocumentFile">X</span>
      </span>
      <input type="file" id='photo' @change='loadFile' hidden ref="loadFile"/>
    </td>
    <td>
      <el-date-picker
        type="date"
        v-model="accountDate"
        @change="dateChanged"
        >
      </el-date-picker>
    </td>
    <td>
      <el-date-picker
        type="date"
        v-model="disclosureDate"
        @change="dateChanged"
        >
      </el-date-picker>
    </td>
    <td class="date-pickers">
      <el-date-picker
        type="date"
        v-model="startDate"
        @change="dateChanged"
        >
      </el-date-picker>
      —
      <el-date-picker
        type="date"
        v-model="endDate"
        @change="dateChanged"
        >
      </el-date-picker>
    </td>
    <td>
      <el-date-picker
        type="date"
        v-model="hideDate"
        @change="dateChanged"
        >
      </el-date-picker>
      <p>
        <el-checkbox v-model="document.is_correcting" @change="handleUpdate">Корректировка</el-checkbox>
      </p>
    </td>
    <td class="delete-cell">
      <img src="/static/img/icons/delete.svg" class="delete-icon" @click="deleteFinancialDocument(document.id)"/>
    </td>
  </tr>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'DocumentItem',
  data () {
    return {
      updateTimer: null,
      startDate: '',
      endDate: '',
      hideDate: '',
      disclosureDate: '',
      accountDate: ''
    }
  },
  props: {
    document: {
      required: true
    }
  },
  created () {
    this.startDate = this.document.startDate
    this.endDate = this.document.endDate
    this.accountDate = this.document.accountDate
    this.disclosureDate = this.document.disclosureDate
    this.hideDate = this.document.hideDate
  },
  filters: {
    path (path) {
      return path.split('/').pop()
    }
  },
  methods: {
    ...mapActions(['deleteFinancialDocument', 'loadFinancialDocumentFile', 'updateFinancialDocument']),
    handleUpdate () {
      this.updateFinancialDocument(this.document)
    },
    loadFile (e) {
      const formData = new FormData()
      const file = e.target.files[0]
      formData.set('document', file)
      this.document.newFile = formData
      this.document.file = file.name
      this.updateFinancialDocument(this.document)
      this.$forceUpdate()
    },
    handleloadFile () {
      this.$refs.loadFile.click()
    },
    deleteDocumentFile () {
      delete this.document.newFile
      this.document.file = ''
      this.updateFinancialDocument(this.document)
      this.$forceUpdate()
    },
    dateChanged () {
      this.document.startDate = this.startDate
      this.document.endDate = this.endDate
      this.document.accountDate = this.accountDate
      this.document.hideDate = this.hideDate
      this.document.disclosureDate = this.disclosureDate
      this.handleUpdate()
    }
  }
}
</script>
<style scoped>
.document .delete-icon {
  position: initial;
  width: 27px;
  margin-top: 5px;
}
.document td {
  padding: 20px 10px;
}
.documents tr {
  border-bottom: 1px solid lightgray;
  border-top: 1px solid lightgray;
}
.delete-cell {
  width: 47px;
  min-width: 47px;
}
.document .document-number {
  width: 110px;
  padding-left: 0;
}
.link {
  max-width: 150px;
}
.document-name {
  padding-left: 25px;
}
.delete-document {
  color: gray;
  font-size: 20px;
  vertical-align: middle;
  margin: 0 0 0 7px;
  font-family: monospace;
  cursor: pointer;
}
</style>
<style>
.document .el-checkbox__label {
  margin-left: 5px;
}
.document .el-checkbox {
  margin-top: 7px;
}
.financial-document .el-date-editor{
  max-width: 170px;
}
</style>



// WEBPACK FOOTER //
// DocumentItem.vue?4c668e30